import instagramIcon from "../images/Instagram.svg";
import "../css/simple-text.css"
import React from "react";

export default function Footer(): React.ReactElement {
  return (
    <footer className="pb-10">
      <div className="bg-gray-300 bg-opacity-10 sm:bg-opacity-20 h-12 sm:h-24 px-12 flex justify-center items-center">
        <div className="flex flex-row gap-8 items-center sm:justify-center flex-none w-72 sm:w-auto">
          <div className="uppercase opacity-90">Physiolymp Saar</div>
          <div className="select-none">
            <a href="#">
              <img
                src={instagramIcon}
                alt="Instagram"
                width="41"
                className="opacity-70 hover:opacity-90"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        className="flex flex-row justify-center"
        style={{ fontSize: "0.8rem", marginTop: "2.5rem" }}
      >
        <div className="flex flex-col-reverse sm:flex-row gap-12 w-72 sm:w-auto">
          <div className="flex flex-row gap-8 items-center -mx-4 md:mx-0">
            <a href="datenschutz" className="opacity-50 hover:opacity-80 p-4">
              Datenschutz
            </a>
            <a href="impressum" className="opacity-50 hover:opacity-80 p-4">
              Impressum
            </a>
          </div>
          <div className="flex flex-col sm:flex-row gap-8 opacity-50 border-gray-500 sm:border-l sm:pl-8">
            <div>
              Tim Martin, Physiotherapie & Osteopathie
              <br />
              Rischbachstraße 17, 66389 St. Ingbert
              <br />
              Tel.: 06894 5820122
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
